/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  ChangePasswordRequest,
  PostApiChangePassword400,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type postApiChangePasswordResponse204 = {
  data: void
  status: 204
}

export type postApiChangePasswordResponse400 = {
  data: PostApiChangePassword400
  status: 400
}

export type postApiChangePasswordResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiChangePasswordResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type postApiChangePasswordResponseSuccess = (postApiChangePasswordResponse204) & {
  headers: Headers;
};
export type postApiChangePasswordResponseError = (postApiChangePasswordResponse400 | postApiChangePasswordResponse401 | postApiChangePasswordResponse403) & {
  headers: Headers;
};

export type postApiChangePasswordResponse = (postApiChangePasswordResponseSuccess | postApiChangePasswordResponseError)

export const getPostApiChangePasswordUrl = () => {


  

  return `/api/change-password`
}

export const postApiChangePassword = async (changePasswordRequest: ChangePasswordRequest, options?: RequestInit): Promise<postApiChangePasswordResponse> => {
  
  return customFetch<postApiChangePasswordResponse>(getPostApiChangePasswordUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      changePasswordRequest,)
  }
);}


